class LocalStorage {
    constructor() {
        this.option_name = 'bth_ls_data';
        this.ls = window.localStorage;
        this.data = this.__getAllData();
    }

    save(data = {}) {
        this.data = { ...this.data, ...data };
        this.ls.setItem( this.option_name, JSON.stringify( this.data ) );
        return this;
    }

    get(key) {
        this.data = this.__getAllData();
        return ( this.data.hasOwnProperty( key ) ? this.data[key] : null );
    }

    set(key, data) {
        this.data[key] = data;
        return this;
    }

    __getAllData() {
        let lsData = this.ls.getItem( this.option_name );
        if ( lsData ) {
            return JSON.parse( lsData );
        }
        return {};
    }
}

export default LocalStorage;
